<div class="action-column">
  @if (showAdminActions) {
    <a
      [attr.id]="item?.document ? 'action-delete-' + item.document : null"
      (click)="onActionClick('delete')"
      [matTooltip]="deleteTooltip"
      matTooltipClass="custom-tooltip"
      class="action-link">
      <em class="far fa-trash-alt"></em>
    </a>
  }

  @if (showAdminActions && !isAlert30DaysWallet) {
    <a
      [attr.id]="item?.document ? 'action-edit-' + item.document : null"
      (click)="onActionClick('edit')"
      [matTooltip]="editTooltip"
      matTooltipClass="custom-tooltip"
      class="action-link">
      <em class="fas fa-pencil-alt"></em>
    </a>
  }

  <a
    [attr.id]="item?.document ? 'action-favorite-' + item.document : null"
    (click)="onActionClick('toggleFavorite')"
    [matTooltip]="favoriteTooltip"
    matTooltipClass="custom-tooltip"
    class="action-link">
    <em [class]="favoriteIconClass"></em>
  </a>

  <a
    [attr.id]="item?.document ? 'action-evolution-' + item.document : null"
    (click)="onActionClick('attributesEvolution')"
    [matTooltip]="attributesEvolutionTooltip"
    matTooltipClass="custom-tooltip"
    class="action-link"
    >
    <em class="fas fa-chart-line"></em>
  </a>
</div>
